module.exports = __webpack_public_path__ + "img/trip-icon_espontaneo.70e81a76.svg";